import { Box, Button, Icon, InputGroup, InputLeftElement, Input, Text } from '@chakra-ui/react'
import useValidateOnChange from 'src/hooks/useValidateOnChange'
import { P } from '../typography/typography'
import { FiUser } from 'react-icons/fi'
import BackButton from './BackButton'

function DisplayNameFieldSet(props) {

  const {
    onNext,
    onBack,
    display,
    register,
    autoFocus = true,
  } = props

  const { isValid, onChange } = useValidateOnChange(displayName => Boolean(displayName && displayName.length < 30))

  const onKeyDown = e => {
    if (e.key === 'Enter') onNext()
  }

  return (
    <Box
      display={display}
    >
      <Box
        layerStyle='cardPadding'
      >
        <P>
          Display name
        </P>
        <Text
          as='label'
          textStyle='label'
          d='block'
          // @ts-ignore
          htmlFor='displayName'
        >
          This is what other users will see
        </Text>
        <InputGroup mt={4}>
          <InputLeftElement
            pointerEvents='none'
            children={<Icon
              as={FiUser}
              height='14px'
              color='primary.accent3'
            />}
          />
          <Input
            pl={8}
            onChange={onChange}
            ref={register}
            onKeyDown={onKeyDown}
            name='displayName'
            id='displayName'
            type='text'
            placeholder='Display name'
            autoFocus={autoFocus}
          />
        </InputGroup>
      </Box>
      <Box
        layerStyle='cardFooter'
        alignItems='center'
        justifyContent='space-between'
      >
        <BackButton display='block' onClick={onBack} />
        <Button
          onClick={onNext}
          disabled={!isValid}
        >
          Next →
        </Button>
      </Box>
    </Box>
  )
}

DisplayNameFieldSet.displayName = "DisplayNameFieldSet"
export default DisplayNameFieldSet
